<template>
    <div class="chileTable">
        <HelpUserStat :groupName="groupName" :params="params" :isRoot="isRoot" />
    </div>
</template>
  
<script>

export default {
    name: "HelpUserExpand",
    props: {
        groupName: {
            type: String,
            required: true,
        },
        params: {
            type: Object,
            required: true,
        },
        isRoot:{
            type:Boolean,
            default:false,
        }
    },
    computed: {
    },
    components: {
        HelpUserStat:()=>import ('./HelpUserStat.vue')
    },
};
</script>

<style lang="less" scoped>
.chileTable > thead {
    display: none;
}